<template>
  <div>
    <v-tour
      name="tutorial"
      :steps="steps"
      :options="options"
      :callbacks="callbacks"
      style="background-color: var(--v-primary-base); color: #FFFFFF"
    >
      <template slot-scope="tour">
        <transition name="fade">
          <v-step
            v-if="tour.steps[tour.currentStep]"
            :key="tour.currentStep"
            :step="tour.steps[tour.currentStep]"
            :previous-step="tour.previousStep"
            :next-step="tour.nextStep"
            :stop="tour.stop"
            :skip="tour.skip"
            :is-first="tour.isFirst"
            :is-last="tour.isLast"
            :labels="tour.labels"
            style="background-color: var(--v-primary-base); color: #FFFFFF"
          >
            <!-- style="background-color: var(--v-secondary-base); color: #FFFFFF" -->
            <template>
              <div slot="header">
                <div v-if="tour.steps[tour.currentStep].header">
                  <h2 v-if="tour.steps[tour.currentStep].header.title" v-html="tour.steps[tour.currentStep].header.title" class=mb-2></h2>
                </div>
              </div>

              <div slot="actions">
                <v-row>
                  <v-col cols="6">
                    <v-btn v-if="tour.enabledButtons.buttonPrevious" block color="secondary" @click="tour.previousStep" class="btn btn-primary">Atrás</v-btn>
                  </v-col>
                  <v-col cols="6">
                    <v-btn v-if="tour.enabledButtons.buttonNext" block color="secondary" @click="tour.nextStep" class="btn btn-primary">Siguiente</v-btn>
                    <v-btn v-else-if="tour.enabledButtons.buttonStop" block color="secondary" @click="tour.nextStep" class="btn btn-primary">Finalizar</v-btn>
                  </v-col>
                </v-row>
              </div>
            </template>
          </v-step>
        </transition>
      </template>
    
    </v-tour>
  </div>
</template>
<script>
import { user as api_user } from "@/api/user";
import { mapActions, mapGetters } from "vuex";
import { STATUS } from "@/store/modules/me.js";
import { ACTIONS } from "@/store/modules/tutorial.js";
import { sleep } from "@/utils.js";
import { mapFields } from 'vuex-map-fields';

export default {
  name: "Tutorial",
  data() {
    return {
      options: {
        useKeyboardNavigation: false,
        enabledButtons: {
          buttonSkip: false,
          buttonPrevious: true,
          buttonNext: true,
          buttonStop: true,
        },
      },
      callbacks: {
        onNextStep: this.onNextStep,
        onPreviousStep: this.onPreviousStep,
        onFinish: this.onFinish,
      },
      expectedNextRoute: undefined,
      currentStep: -1,
      steps: [
        {
          save: true,
          target: "#select-companydb",
          header: {
            title: "¡Bienvenido!",
          },
          content: `
            Ahora vamos a guiarte en como empezar a procesar facturas.
            <br />
            Primero de todo, tenemos que registrar una empresa a la que vamos a facturar.
            `,
          before: async () => {
            this.options.enabledButtons.buttonPrevious = false;
            this.options.enabledButtons.buttonStop = false;
            if (this.$route.name !== "document-list") {
              this.$router.push({ name: "document-list" });
              await sleep(500);
            }
            var checkExist = setInterval(async function() {
              if (document.getElementById("select-companydb")) {
                  clearInterval(checkExist);
              }
              await sleep(100);
            }, 100);
            await sleep(500);
          },
        },
        {
          save: true,
          target: "#app > div.v-menu__content",
          header: {
            title: "Vamos a añadir una empresa a la que facturar",
          },
          params: {
            placement: "left",
          },
          content: "Para ello, tenemos que ir a la sección 'Mis Empresas'.",
          before: async () => {
            this.options.enabledButtons.buttonPrevious = true;
            this.options.enabledButtons.buttonStop = false;
            if (this.$route.name !== "document-list") {
              this.$router.push({ name: "document-list" });
              await sleep(500);
            }
            this.options.enabledButtons.buttonNext = true;
            this.sendTutorialAction(ACTIONS.OPEN_ACCOUNT);
            await sleep(100);
            this.goNextStepWhenRouteChangeTo("connectors");
          },
        },
        {
          save: true,
          target:
            "#app > div.v-application--wrap > main > div > div > div > div.row > div > div > div.v-card__title > button:nth-child(4)",
          header: {
            title: "Vamos a añadir una empresa",
          },
          content: "Hacemos click en el botón de añadir empresa.",
          before: async () => {
            this.options.enabledButtons.buttonNext = false;
            this.options.enabledButtons.buttonStop = false;
            if (this.$route.name !== "connectors") {
              this.$router.push({ name: "connectors" });
              await sleep(500);
            }
            this.goNextStepWhenRouteChangeTo("connector-create");
          },
        },
        {
          name: "select-connector-type",
          target: "#select-connector-type",
          header: {
            title: "Tipo de conector",
          },
          params: {
            placement: "right",
            enableScrolling: false,
          },
          content: "Seleccionamos el programa conector.",
          before: async () => {
            this.options.enabledButtons.buttonNext = false;
            this.options.enabledButtons.buttonStop = false;
            if (this.$route.name !== "connector-create") {
              this.$router.push({ name: "connector-create" });
              await sleep(500);
            }
            this.sendTutorialAction(ACTIONS.SELECT_CONNECTOR_TYPE);
          },
        },
        {
          name: "help-connector-type-id",
          target: "#connector-link-path",
          header: {
            title: "Información de la empresa",
          },
          params: {
            placement: "bottom",
            enableScrolling: false,
          },
          content: "-", // watch.connectorType sets the content
          before: async () => {
            this.options.enabledButtons.buttonNext = true;
            this.options.enabledButtons.buttonStop = false;
          },
        },
        {
          name: "help-create-connector",
          target: "#create-connector-btn",
          header: {
            title: "Creación de la empresa",
          },
          content: "Una vez rellenada la información necesaria creamos la empresa.",
          before: async () => {
            this.options.enabledButtons.buttonNext = false;
            this.options.enabledButtons.buttonStop = false;
            let that = this;
            var checkExist = setInterval(async function() {
              if (that.show_message) {
                  clearInterval(checkExist);
                  await sleep(500);
                  that.$tours.tutorial.nextStep();
              }
            }, 100);

          },
        },
        {
          target: "#ok-btn",
          header: {
            title: "¡Felicidades!",
          },
          params: {
            placement: "right",
          },
          content: "Ya estás listo para usar Inmatic.",
          before: async () => {
            this.options.enabledButtons.buttonNext = false;
            this.options.enabledButtons.buttonStop = false;
            this.options.enabledButtons.buttonPrevious = false;
            let that = this;
            var isFinished = setInterval(function() {
              if (that.$router.currentRoute.name == 'connectors') {
                  clearInterval(isFinished);
                  that.$tours.tutorial.finish();
              }
            }, 100);
          },
        },
      ],
    };
  },
  created() {
    this.setUpTutorial();
  },
  methods: {
    onNextStep() {
      this.currentStep = this.$tours.tutorial.currentStep + 1;
    },
    onPreviousStep() {
      this.currentStep = this.$tours.tutorial.currentStep - 1;
    },
    async onFinish() {
      await api_user.setUserInfo({
        status: STATUS.TRIAL,
      });
    },
    setUpTutorial() {
      if (
        !this.inProgress &&
        this.userData.status === STATUS.DOING_TUTORIAL &&
        this.$tours["tutorial"]
      ) {
        this.currentStep = this.userData.tutorial_step || 0;
        this.$tours["tutorial"].start(this.currentStep);
        this.startTutorial(this.$tours["tutorial"]);
      }
    },
    ...mapActions({
      startTutorial: "tutorial/startTutorial",
      setCurrentStep: "tutorial/setCurrentStep",
      sendTutorialAction: "tutorial/sendTutorialAction",
      onAction: "tutorial/onAction",
    }),
    goNextStepWhenRouteChangeTo(routeName) {
      this.expectedNextRoute = routeName;
    },
  },
  computed: {
    ...mapGetters({
      userData: "me/userData",
      inProgress: "tutorial/inProgress",
      storeCurrentStep: "tutorial/numStep",
      connectorType: "tutorial/connectorType",
    }),
    ...mapFields('connector', {
      show_message: 'show_message'
    }),
  },
  watch: {
    userData() {
      this.setUpTutorial();
    },
    async currentStep() {
      if (!this.inProgress) return;
      this.setCurrentStep(this.currentStep);
      if (this.steps[this.currentStep].save) {
        await api_user.setUserInfo({
          tutorial_step: this.currentStep,
        });
      }
    },
    connectorType() {
      if (!this.inProgress) return;
      const stepIdx = this.steps.findIndex(
        (step) => step.name === "help-connector-type-id"
      );
      this.steps[
        stepIdx
      ].content = `Inserta ${(this.connectorType && this.connectorType.params && this.connectorType.params.show && this.connectorType.params.show.includes('nst_files')) ? 'la ruta' : 'el ID' } para el conector ${this.connectorType.name}.`;
      const selectStepIdx = this.steps.findIndex(
        (step) => step.name === "select-connector-type"
      );
      // if we are on select-connector-type step, go next step
      if (this.currentStep === selectStepIdx) {
        this.$tours.tutorial.nextStep();
      }
    },
    $route: function (to, from) {
      if (
        this.inProgress &&
        this.expectedNextRoute &&
        to.name === this.expectedNextRoute
      ) {
        this.expectedNextRoute = undefined;
        this.$tours.tutorial.nextStep();
      }
    },
  },
  mounted() {
    this.setUpTutorial();
  },
};
</script>
<style>
  .v-step__header {
    background-color: aquamarine;
  }
</style>
